import { Node, mergeAttributes } from "@tiptap/core"

export interface ButtonOptions {
  HTMLAttributes: Record<string, any>
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    button: {
      setButton: (attributes: { href: string; label: string }) => ReturnType
    }
  }
}

export const ButtonNode = Node.create<ButtonOptions>({
  name: "button",
  group: "block",
  atom: true,

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  addAttributes() {
    return {
      href: { default: null },
      label: { default: "Click here" },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'a[data-type="button"]',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "a",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        "data-type": "button",
        class: "email-button",
        style:
          "display:inline-block;padding:12px 24px;background-color:#2563eb;color:#ffffff;text-decoration:none;border-radius:6px;font-weight:600;font-size:16px;text-align:center;",
        target: "_blank",
        rel: "noopener noreferrer",
      }),
      HTMLAttributes.label || "Click here",
    ]
  },

  addCommands() {
    return {
      setButton:
        (attributes) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: attributes,
          })
        },
    }
  },
})

export default ButtonNode
